import modalMixin from '../../mixins/_modal';
import templateSelecter from '../../components/_template_selecter';
import modalStoreTemplateChangeConfirm from './_modal_store_template_change_confirm';

/**
 * ストアテンプレート選択モーダル
 */
export default {
    name: 'modalStoreTemplateChange',
    template: '#modal_store_template_change',
    data() {
        return {
            // 選択されたストアテンプレートのデータ
            selectedTemplateData: {}
        };
    },
    mixins: [
        modalMixin,
    ],
    /**
     * コンポーネント群
     */
    components: {
        // テンプレート選択コンポーネント
        'template-selecter': templateSelecter,
        // ストアテンプレートリセット確認モーダル
        'modal-store-template-change-confirm': modalStoreTemplateChangeConfirm,
    },
    emits: ['store-template-change'],
    methods: {
        // リセット確認モーダル表示
        showModalConfirm: function (template) {
            this.selectedTemplateData = template;
            this.$refs.modal_store_template_change_confirm.open();
        },
        // _editのストアテンプレート変更のプレビュー呼び出し
        openPreview: function(template){
            this.$root.$refs.edit.openPreview(template.data);
        },
        // templateを変更
        emitStoreTemplateChange: function(isTakeOver) {
            // テンプレートデータと連動フラグを分けた配列を作ってそれを返す
            const deviceSync = this.selectedTemplateData.device_sync;
            let template = _.cloneDeep(this.selectedTemplateData);
            delete template.device_sync;

            this.$emit('store-template-change', [template, deviceSync], isTakeOver);
            this.close();
        },
    }
};